function Aggregator_form_container_edit(element) {
	this.$element = $(element);
	this.popup = i4_Popup.get(this.$element);
	
	this.data = {
		containerID: 'container-id',
	    imageDelete: 'image-delete',
	    imageMove: 'image-move'
	};

	this.init = function() {
		
		// console.log('Aggregator_form_container_edit - init()');
		
		this.dataContainerID = this.$element.data(this.data.containerID);
	    this.dataImageDelete = this.$element.data(this.data.imageDelete);
	    this.dataImageMove = this.$element.data(this.data.imageMove);
	    
		this.initListEditor();
	};

	this.initListEditor = function() {
		
		i4_List_editor.get('aggregator_container_edit').
			set_element_result_id('list_plugin_result').
			set_ajax_parameter({
			    js: 'aggregator',
			    call: 'plugin_list_edit',
			    container_id: this.dataContainerID
			}).
			set_option({
				image_delete: this.dataImageDelete, 
				image_move: this.dataImageMove,
				after_delete_item: (function() {
					this.popup.set_layout().renew_position();
					this.renewUsedList();
					this.updateSelect();
				}).bind(this),
				after_add_item: (function() {
					this.popup.set_layout().renew_position();
					this.renewUsedList();
					this.updateSelect();
				}).bind(this),
				after_load: (function() {
					this.popup.set_layout().renew_position();
				}).bind(this)
			}).
			run();
	};
	
	this.renewUsedList = function() {
		this.usedList = [];
		
		$("#list_plugin_result input, #list_plugin_result select").each((function(i, item){
			if ($(item).attr("id") != "list_save") {
				this.usedList.push($(item).val());
			}
		}).bind(this));
	};
	
	this.updateSelect = function() {
		$("#list_plugin_result select").each((function(i, select) {
			$("#"+select.id+" option").each((function(i, option) {			
				if ($.inArray(option.value, this.usedList) > -1 && select.value != option.value) {
				    option.disabled = "disabled";
				} else {
					option.disabled = "";
				}
			}).bind(this));
		}).bind(this));
	};

}